import { useSetRecoilState } from "recoil";
import { settingsAtom } from "../miscellaneous/settingsAtom";

export function useSetSettingsState() {
  return useSetRecoilState(settingsAtom);
}
